<template>
    <div class="d-inline-block mr-4" @keydown.esc="closeSearch()">
        <a-input
            ref="outerInput"
            :class="$style.extInput"
            :placeholder="$t('topBar.typeToSearch')"
            style="width: 200px"
            @focus="openSearch"
        >
            <template #prefix>
                <span>
                    <search-outlined style="color: rgba(0, 0, 0, 0.25)" />
                </span>
            </template>
        </a-input>

        <div :class="[$style.livesearch, showSearch ? $style.livesearchVisible : '']">
            <button :class="$style.close" type="button" @click="closeSearch">
                <i class="fe fe-x" />
            </button>
            <div class="container-fluid">
                <div :class="$style.wrapper">
                    <input
                        ref="innerInput"
                        v-model="searchText"
                        :class="$style.searchInput"
                        :placeholder="$t('topBar.typeToSearch')"
                        @input="onSearch"
                    />

                    <!--<ul :class="$style.options">
            <li :class="[$style.option, $style.optionCheckbox]">
              <a-checkbox checked> Search within page </a-checkbox>
            </li>
            <li :class="$style.option">Press enter to search</li>
          </ul>-->

                    <a-list item-layout="horizontal" :data-source="routesFiltered" :locale="noData">
                        <template #renderItem="{ item }">
                            <a-list-item>
                                <a-list-item-meta>
                                    <template #title>
                                        <a href="#" @click.prevent="goTo(item.name)">{{
                                            item.meta.title
                                        }}</a>
                                    </template>
                                    <!--<template #avatar>
                    <a-avatar
                      src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                    />
                  </template>-->
                                </a-list-item-meta>
                            </a-list-item>
                        </template>
                    </a-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, defineComponent } from 'vue'
import { SearchOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'
import Fuse from 'fuse.js'

export default defineComponent({
    components: {
        SearchOutlined,
    },
    setup() {
        const showSearch = ref(false)
        const searchText = ref('')
        const innerInput = ref(null)
        const routesFiltered = ref([])

        const noData = {
            emptyText: 'Sem resultados!',
        }

        /******************************************************************************
         * Obter todas as routes para páginas
         */
        const router = useRouter()

        const allRoutes = router.options.routes

        const routerPages = allRoutes[0].children

        /******************************************************************************
         * Pesquisar
         */
        const onSearch = searchValue => {
            let result = routerPages
            // obter a lista de routes ativas
            let routerPagesEnabled = result.filter(function (product) {
                
                return product.disabled == false
            })

            // texto da pesquisa
            let text = searchText.value

            if (text != '') {
                // threshold is a float declaring how sensitive the search algorithm is. A threshold of 0.0 will require a perfect match.
                // https://www.fusejs.io/concepts/scoring-theory.html#fuzziness-score
                const options = {
                    ignoreLocation: true,
                    threshold: 0.2,
                    keys: ['meta.title'],
                }

                const fuse = new Fuse(routerPagesEnabled, options)
                routesFiltered.value = fuse.search(text).map(r => r.item)
            } else {
                // limpar o array da pesquisa
                routesFiltered.value = []
            }
        }

        const goTo = goTopath => {
            router.push({ name: goTopath })
            closeSearch()
        }

        /******************************************************************************
         * Bloco da pesquisa
         */

        // quando se clica no input da pesquisa
        const openSearch = () => {
            showSearch.value = true
            setTimeout(() => {
                innerInput.value.focus()
            }, 100)
        }

        const closeSearch = () => {
            showSearch.value = false
        }

        /******************************************************************************
         * return de info para o template
         */
        return {
            showSearch,
            searchText,
            openSearch,
            closeSearch,
            innerInput,
            onSearch,

            routesFiltered,
            noData,
            goTo,
        }
    },
})
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
